import { BreakPointCondition, InputTypes, UI, useBreakpointIf, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React, { useState } from 'react';

export interface DateSelectionProps {
  selectedValue?: Date;
  onValueChange: (value?: Date) => void;
  forceMobile?: boolean;
}

export const DateSelection: React.FC<DateSelectionProps> = ({
  selectedValue,
  onValueChange,
  forceMobile,
}) => {
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');
  const [invalidDate, setInvalidDate] = useState(false);
  const [hasBeenFocused, setHasBeenFocused] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
    setInvalidDate(false);
    setHasBeenFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleUpdateDateSelected = (date: Date) => {
    if (date && Utils.Date.IsFuture(date)) {
      onValueChange(undefined);
      setInvalidDate(true);
      return;
    }
    onValueChange(date);
  };

  return (
    <VStack space="inline.nano" zIndex={10} flex={1}>
      <UI.Text variant="semibold">Data</UI.Text>
      <Box
        maxW={
          forceMobile ? 'full' : Utils.Responsive.PhoneTablet({ phone: 'full', tablet: '240px' })
        }
        w="full">
        <UI.DatePicker
          date={selectedValue}
          onClear={onValueChange}
          onSelectDate={handleUpdateDateSelected}
          availableRange={{ future: new Date() }}
          calendarPosition="left"
          placeholder="Selecione uma data"
          inputComponentProps={
            { onFocus: handleFocus, onBlur: handleBlur } as unknown as InputTypes.Props
          }
          error={
            hasBeenFocused && !isFocused && !selectedValue
              ? { message: invalidDate ? 'Data inválida' : 'Campo obrigatório' }
              : undefined
          }
          forceMobile={isTablet}
        />
      </Box>
    </VStack>
  );
};
